import { EHlasovaciPrava } from 'enums/isin/udaje/hlasovaciPrava';

const hlasovaciPravaSelect = [
    {
        value: EHlasovaciPrava.B,
        labelcz: 'ISIN_EMISE_AKCIE_HLASOVACI_B'
    },
    {
        value: EHlasovaciPrava.S,
        labelcz: 'ISIN_EMISE_AKCIE_HLASOVACI_S'
    },

    {
        value: EHlasovaciPrava.O,
        labelcz: 'ISIN_EMISE_AKCIE_HLASOVACI_O'
    },
    {
        value: EHlasovaciPrava.Z,
        labelcz: 'ISIN_EMISE_AKCIE_HLASOVACI_Z'
    }
];

export default hlasovaciPravaSelect;
